import { Col, Table } from "react-bootstrap";
import InspectionItem from "./inspectionitem";
import InspectionsQuickAdd from "./inspectionsquickadd";

const InspectionsPanel = ({fields,setFields,ActionTypes = [],InspectionStatuses = [],InspectionTypes = []}) => {
    const remove = (id) => {
        setFields((prev) => prev.filter(item => item.id !== id));
    }

    const update = (id, data) => {
        setFields(prev => 
            prev.map(item => (item.id === id ? {...item,...data} : item))
        );
    }

    const prepend = (obj) => {
        setFields([obj, ...fields]);
    }

    return(
        <Col xs={12}>
            <h5 className="text-center">Inspections</h5>
            <Table hover striped responsive size="sm" bordered>
                <thead>
                    <tr>
                        <th>Inspection Type</th>
                        <th>Inspection Date</th>
                        <th>Inspection Status</th>
                        <th>Inspection Report</th>
                        <th>Comments</th>
                        <th>Client Signed Waiver</th>
                        <th>Waiver Status</th>
                        <th>Last Modified Date</th>
                        <th>Last Modified By</th>
                        <th style={{width: '1%'}}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <InspectionsQuickAdd 
                        ActionTypes={ActionTypes}
                        InspectionStatuses={InspectionStatuses}
                        InspectionTypes={InspectionTypes}
                        prepend={prepend}
                    />
                    {
                        fields.map((item) => (
                            <InspectionItem
                                key={item.id}
                                Inspection={item}
                                ActionTypes={ActionTypes}
                                InspectionStatuses={InspectionStatuses}
                                InspectionTypes={InspectionTypes}
                                update={update}
                                remove={remove}
                            />
                        ))
                    }
                </tbody>
            </Table>
        </Col>
    )
}

export default InspectionsPanel;